var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-lg-12" }, [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-header" }, [
          _c("div", { staticClass: "card-tools" }, [
            _c(
              "a",
              {
                staticClass: "btn btn-block btn-info",
                attrs: {
                  href:
                    "/sites/create?context=" +
                    this.context +
                    "&context_id=" +
                    this.context_id
                }
              },
              [
                _vm._v(
                  "\n                        Create Site\n                    "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("h4", [_vm._v("Sites")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-body" }, [_c("div", { ref: "table" })])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }